import React, {useState} from 'react';
import TeacherTrailsDashboardWidget from "./TeacherTrailsDashboardWidget";

const TeacherTrailsDashboardWidgetUSA = () => {
    const [isLoading, setLoading] = useState(false);

    return (
        <>
            <div className={'ch-dashboard-usa-plans-widget'}>
                <h2>Manage your student plans</h2>
                <div>
                    <TeacherTrailsDashboardWidget />
                </div>
            </div>
        </>
    )
}

export default TeacherTrailsDashboardWidgetUSA;